import { types } from 'mobx-state-tree';

export const Profit = types.model('profit', {
  profitPercent: types.maybe(types.number),
  profitCurrencyUnits: types.maybe(types.number),
  breakEven: types.maybe(types.number),
  sourcePrice: types.maybe(types.number),
  destinationPrice: types.maybe(types.number),
  minimalProfitCurrencyUnits: types.maybe(types.number),
  minimalProfitPercent: types.maybe(types.number),
  optimalProfitCurrencyUnits: types.maybe(types.number),
  optimalProfitPercent: types.maybe(types.number),
  up: types.maybe(types.number),
  down: types.maybe(types.number),
  downDays: types.maybe(types.number),
  strategyType: types.maybe(types.number),
  strategyId: types.maybe(types.number),
  profitType: types.maybe(types.number),
});
